<template lang="pug">
.menu(:class="{'nav-open': $sidebar.showSidebar}")
  side-bar
    img.brand(v-on:click="getStatus"  alt="logo" style="cursor:pointer;width: 80px;position: relative;top: 24px; left: 10px;" src="/img/logo-orange.png")
    span.brand Asia Alternatives
    template(slot-scope='props', slot='links')
      sidebar-item(:link="{name: 'Home', icon: 'fas fa-home', path: '/'}")
      sidebar-item(:link="{name: 'Excavation', icon: 'fas fa-city', path: '/excavation'}")
      sidebar-item(:link="{name: 'Commitment', icon: 'fa fa-usd', path: '/commitment'}")
        sidebar-item.submenu(:link="{name: 'Summary by Geography', icon: 'fas fa-chart-pie', color: 'blue', path: '/reports/sbg'}")
        sidebar-item.submenu(:link="{name: 'Summary by Asset Class', icon: 'fas fa-chart-pie', color: 'blue', path: '/reports/sbac'}")
        sidebar-item.submenu(:link="{name: 'Summary by Defined Strategy', icon: 'fas fa-chart-pie', color: 'blue', path: '/reports/sbds'}") 
        sidebar-item.submenu(:link="{name: 'Summary by Defined Manager', icon: 'fas fa-chart-pie', color: 'blue', path: '/reports/sbdm'}")
        sidebar-item.submenu(:link="{name: 'Summary by Fund Size', icon: 'fas fa-chart-pie', color: 'blue', path: '/reports/sbfs'}")
        sidebar-item.submenu(:link="{name: 'Summary by Vintage', icon: 'fas fa-chart-pie', color: 'blue', path: '/reports/sbv'}")
      sidebar-item(:link="{name: 'Entity DB', icon: 'fas fa-balance-scale', path: '/entitydb'}")
        sidebar-item.submenu(:link="{name: 'Company Details', icon: 'fas fa-chart-pie', color: 'blue', path: '/entitydb/cd'}")
        sidebar-item.submenu(:link="{name: 'LPA Amendments', icon: 'fas fa-chart-pie', color: 'blue', path: '/entitydb/la'}")
        sidebar-item.submenu(:link="{name: 'Regulatory Tax', icon: 'fas fa-chart-pie', color: 'blue', path: '/entitydb/rt'}")
      sidebar-item(:link="{name: 'Cash Management', icon: 'fa fa-usd', path: '/cashmanagement'}")
        sidebar-item.submenu(:link="{name: 'Bulk Upload', icon: 'fas fa-chart-pie', color: 'blue', path: '/CashManagement/bulkupload'}")
        sidebar-item.submenu(:link="{name: 'Select', icon: 'fas fa-chart-pie', color: 'blue', path: '#'}")
        sidebar-item.submenu(:link="{name: 'Select', icon: 'fas fa-chart-pie', color: 'blue', path: null}")
        Dropdown.submenu(style="margin-left: 75px" v-on:selected="goToRoute"  :placeholder="'Select'" v-on:filter="getDropdownValues" :options="selectedData" :maxItem="100")
      sidebar-item(:link="{name: 'ODD', icon: 'fas fa-home', path: '/odd'}")
      sidebar-item(:link="{name: 'GP Master', icon: 'fas fa-handshake', path: '/GPMaster'}")
      sidebar-item(:link="{name: 'Funds', icon: 'fas fa-pound-sign', path: '/Fund'}")
      sidebar-item(:link="{name: 'Direct', icon: 'fas fa-location-arrow', path: '/Direct'}")
      sidebar-item(:link="{name: 'Assets', icon: 'fas fa-suitcase', path: '/Asset'}")
      sidebar-item(:link="{name: 'Legal Entity Funds', icon: 'fas fa-th-large', path: '/LEFund'}")
      sidebar-item(:link="{name: 'Fund Assets', icon: 'fas fa-archive', path: '/FundAsset'}")
  .main-panel
    router-view(name='header')
    div(:class='{content: !$route.meta.hideContent}', @click='toggleSidebar')
      zoom-center-transition(:duration='200', mode='out-in')
        // your content here
        router-view
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import Dropdown from '@/plugins/dropdown/Dropdown.vue';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import axios from 'axios';
const routes = require('@/meta.json')
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

/*import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import UserMenu from './Extra/UserMenu.vue';
*/
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    SlideYDownTransition,
    ZoomCenterTransition,
    Dropdown
  },
    data() {
        return {
            selectedData: [],
            routed: {},
            }
            },
  created() {
  routes.forEach( (x,i) => {
  this.selectedData.push({ id: i, name: x.name, route: x.module.replace(/ /g,'_').replace(/\(/g,'').replace(/\)/g,'') })
  this.routed[x.name] = "/CashManagement/" + x.module.replace(/ /g,'_').replace(/\(/g,'').replace(/\)/g,'')
  //this.routed[x.name] = "/CashManagement/ivoryIv"
  //this.getSplitData();
  })
  },
  methods: {
        goToRoute(evt) {
        return;
        console.log(211,evt);
        },
        getUniqueListBy(arr, key) {
            return [...new Map(arr.map(item => [item[key], item])).values()]
        },
        getSplitData() {
            let w = this;
            var data = JSON.stringify({
                "FundID": "222"
            });

            var config = {
                method: 'post',
                url: 'https://asiaaltfunctions.azurewebsites.net/api/querySplits?code=hgG_DtbepOvlh2l-Ep01sYMOMyZkSUsqnQDZHSDgVRgZAzFuX5Uz-A==',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(config)
                .then(function(response) {
                    w.splitdata = response.data;
                    const uniqueData = w.getUniqueListBy(response.data, 'iLevel Deal Name');
                    uniqueData.forEach((element,i) => {
                        w.selectedData.push({id: i, name:element['iLevel Deal Name']})
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });

        },
    getDropdownValues(evt) {
    if ( this.routed[evt] && this.$route.path != this.routed[evt] ) this.$router.push(this.routed[evt])
    },
    getStatus() {
    this.$eventBus.$emit('appEvents', {
                            exec: 'getStatus',
                            component: 'nav'
                        })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    docClasses.add('sidebar-mini');
    docClasses.add('sidebar-menu');
    let isWindows = navigator.platform.startsWith('Win');
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar('sidebar');
      initScrollbar('sidebar-wrapper');

      docClasses.add('perfect-scrollbar-on');
    } else {
      docClasses.add('perfect-scrollbar-off');
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
#app > #page > .menu {
position: absolute;
}

#app .off-canvas-sidebar .nav li:first-child>a, .sidebar .nav li:first-child>a {
    margin: 0 10px;
}

#app .off-canvas-sidebar .nav li>a, .sidebar .nav li>a {
    margin: 10px 10px 0;
	}

body.sidebar-mini .sidebar {
    width: 72px;
}
body.sidebar-menu #app .sidebar:hover span.brand {
    position: absolute;
            left: 64px;
            top: 24px;
            color: white;
            font-size: 1.33em;
            opacity: 1;
        font-weight: 700;
            }

body.sidebar-menu #app .menu span.brand {
    position: absolute;
        left: -100px;
                width: 200px;
                opacity: 0;
                transition: opacity 0.8s;
                }

#app .sidebar-wrapper .logo {
    width: 32px;
    top: 18px;
    left: 19px;
    position: relative;
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
#app #page .ps--active-x > .ps__rail-x {
display: none !important;
}
#app #page .fa-chart-pie {
color: #2ca8ff;
}
.dropdown .dropdown-input[data-v-6149e08a] {
    background: #2c2c2c;
    cursor: pointer;
    border: 1px solid #000;
    border-radius: 3px;
    color: #333;
    display: block;
    font-size: .8em;
    padding: 6px;
    min-width: 200px;
    max-width: 200px;
}
</style>
